import './titletext.less'

import React from 'react'
import {LinkType, WysiwygType} from 'types'
import {style} from 'util/style'
import {Theme} from 'views/theme'

const styles = style('titletext', ['top', 'content'])

export type TitletextType = {id?: string} & TitletextTopType &
	TitletextContentType

export type TitletextTopType = {
	id?: string
	title?: string
	subtitle?: string
	title_align?: 'left' | 'center' | 'right'
}

export type TitletextContentType = {
	text_align?: 'left' | 'center' | 'right'
	text_fullwidth?: boolean
	text?: WysiwygType
	links_layout?: 'button' | 'link'
	links?: Array<LinkType>
}

export const Titletext: React.FC<TitletextType> = ({
	id,
	title,
	subtitle,
	title_align,
	text_align,
	text_fullwidth,
	text,
	links_layout = 'link',
	links
}) => {
	return (
		<div id={id} className={styles()}>
			<Theme.OuterContainer>
				<Theme.Container>
					<TitletextTop
						title={title}
						subtitle={subtitle}
						title_align={title_align}
					/>
					<TitletextContent
						text={text}
						text_align={text_align}
						text_fullwidth={text_fullwidth}
						links_layout={links_layout}
						links={links}
					/>
				</Theme.Container>
			</Theme.OuterContainer>
		</div>
	)
}

export const TitletextTop: React.FC<TitletextTopType> = ({
	title,
	subtitle,
	title_align
}) => {
	if (!title && !subtitle) return null

	return (
		<div className={styles.top().mod(title_align)}>
			{title && (
				<Theme.H2 className={styles.top('title')} mod={['dots']}>
					{title}
				</Theme.H2>
			)}
			{subtitle && (
				<Theme.H3 className={styles.top('subtitle')} mod="light">
					{subtitle}
				</Theme.H3>
			)}
		</div>
	)
}

export const TitletextContent: React.FC<TitletextContentType> = ({
	text,
	text_align,
	text_fullwidth = false,
	links_layout,
	links
}) => {
	if (!text && (!links || links.length === 0)) return null

	return (
		<div
			className={styles
				.content()
				.mod(text_align)
				.mod({fullwidth: !!text_fullwidth})}
		>
			{text && (
				<div className={styles.content('text')}>
					<Theme.Wysiwyg>{text}</Theme.Wysiwyg>
				</div>
			)}
			{links_layout === 'button' ? (
				<Theme.ButtonsMap links={links} className={styles.content('links')} />
			) : (
				<Theme.LinksMap links={links} className={styles.content('links')} />
			)}
		</div>
	)
}
